export default {
  issueDetail: {
    title: '發放明細',
    qrCode: '二維碼',
    qrCodePlaceholder: '請輸入二維碼',
    productInfo: '商品信息',
    productInfoPlaceholder: '請輸入關鍵詞搜索',
    relatedInfo: '關聯信息',
    relatedInfoPlaceholder: '請輸入關鍵詞搜索',
    memberInfo: '會員信息',
    memberInfoPlaceholder: '會員信息',
    issueTime: '發放時間',
    country: '國家',
    issuePoints: '發放積分',
    spec: '規格',
    singleSpec: '單規格',
    memberId: '會員信息',
    direction: '方向',
    directionAdd: '增加',
    directionSubtract: '扣減',
    directionFreeze: '凍結',
    directionUnfreeze: '解凍',
    points: '積分',
    beforePoints: '變動前',
    afterPoints: '變動後',
    sourceType: '來源類型',
    sourceTypeScan: '掃碼',
    sourceTypeActivity: '活動',
    sourceTypeManual: '手動',
    sourceTypeMall: '商城',
    sourceTypeRedPacket: '紅包',
    sourceName: '來源名稱',
    remark: '備註',
    timeRequired: '請選擇發放時間',
  },
  issueStats: {
    title: '發放統計',
    date: '日期',
    totalIssued: '總發放數據',
    totalConsumed: '總消耗數據',
    chartTitle: '近7天積分發放情況',
    rankTitle: '積分發放商品排行',
    rankNo: '排名',
    productDetail: '商品詳情',
    totalPoints: '總發放積分',
    spec: '規格',
    singleSpec: '單規格',
  },
  config: {
    title: '基礎配置/積分規則',
    language: '語言',
    addLang: '添加多語言',
    deleteLang: '刪除多語言',
    deleteLangConfirm: '確認刪除當前語言配置？',
    ruleTitle: '標題',
    content: '內容',
    addLangModalTitle: '添加多語言',
    languagePlaceholder: '請選擇語言',
  },
};
